export enum OnboardingStatus {
    ONBOARDING = 'full_service_onboarding',
    IN_PROGRESS = 'full_service_in_progress',
    CREATION = 'company_creation'
}
